import { render } from "./vagentcensus.vue?vue&type=template&id=bf11eb4c&scoped=true"
import script from "./vagentcensus.vue?vue&type=script&lang=js"
export * from "./vagentcensus.vue?vue&type=script&lang=js"

import "./vagentcensus.vue?vue&type=style&index=0&id=bf11eb4c&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境商户后台shop.jsyinba.com/jsmerchant/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf11eb4c"]])

export default __exports__